import { render, staticRenderFns } from "./ParamError.vue?vue&type=template&id=9966e262&scoped=true"
import script from "./ParamError.vue?vue&type=script&lang=js"
export * from "./ParamError.vue?vue&type=script&lang=js"
import style0 from "./ParamError.vue?vue&type=style&index=0&id=9966e262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9966e262",
  null
  
)

export default component.exports